import stripTrailingSlash from '@/core/utils/strip-trailing-slash';

const cleanPagePathname = (pathname: string): string =>
  stripTrailingSlash(
    pathname
      .replace(/\/\d+/g, '') // Remove numeric IDs
      .replace(/\/[a-f0-9-]{36}/g, '') // Remove UUIDs
      .replace(/\?.*$/, ''),
  ) || '/'; // Default to '/'

export default cleanPagePathname;
